import React, { useState, useEffect } from 'react'
import { useDispatch, useStore } from 'react-redux'
import { Modal } from 'rsuite'
import { Table, Checkbox } from 'rsuite'
import { mergeMasters, addSupplierHistory } from '../../../../redux/actions/vendor'
import { toast } from '../../../CommonComponents/ToastComponent/toast'
import LoaderComponent from '../../../CommonComponents/LoaderComponent'
const { Column, HeaderCell, Cell, Pagination } = Table

export const LinkCell = ({ rowData, dataKey, ...props }) => {
    let bgColorClass = rowData[dataKey] === 'Approved' ? 'bg-green' : rowData[dataKey] === 'Rejected' ? 'bg-red' : 'bg-yellow'
    return (
        <Cell {...props} className="table-link">
            <h5 style={{ width: '60px' }} className={`btn text-white ${bgColorClass}`}>
                {rowData[dataKey]}
            </h5>
        </Cell>
    )
}
const ChildSuppliersModal = ({ show, onClose, masterSupplierData, selectedMasterSuppliers }) => {
    const dispatch = useDispatch()
    const store = useStore().getState()
    const {
        auth: { user }
    } = store
    const [isMergingMasters, setIsMergingMasters] = useState(false)
    const [checkedKeys, setCheckedKeys] = useState([])
    const [checkedSuppliers, setCheckedSuppliers] = useState([])
    const [sortColumn, setSortColumn] = useState();
    const [sortType, setSortType] = useState();
    const [loading, setLoading] = useState(false);
    const [limit, setLimit] = useState(10)
    const [page, setPage] = useState(1)
    const [tableData, setTableData] = useState([])
    const [checked, setChecked] = useState(false)
    const [indeterminate, setIndeterminate] = useState(false)
    const [showNotSelectedChildSuppliersModal, setShowNotSelectedChildSuppliersModal] = useState(false)
    const [headerText, setHeaderText] = useState('Select the children to assign to new master supplier')
    useEffect(() => {
        var childSuppliers = []
        selectedMasterSuppliers.map((supplier) => {
            return supplier.childVendors.map((child) => {
                return childSuppliers.push(child)
            })
        })
        setTableData(childSuppliers)
    }, [])

    useEffect(() => {
        let checked = false
        let indeterminate = false
        if (checkedKeys && tableData && checkedKeys.length === tableData.length && checkedKeys.length > 0) {
            checked = true;
        } else if (checkedKeys && checkedKeys.length === 0) {
            checked = false;
        } else if (checkedKeys && tableData && checkedKeys.length > 0 && checkedKeys.length < tableData.length) {
            indeterminate = true;
        }
        setIndeterminate(indeterminate)
        setChecked(checked)
    }, [checkedKeys])

    const CheckCell = ({ rowData, onChange, checkedKeys, dataKey, disabled, ...props }) => (
        <Cell {...props} style={{ padding: 0 }}>
            <Checkbox
                value={rowData[dataKey]}
                onChange={onChange}
                checked={checkedKeys.some(item => item === rowData[dataKey])}
                disabled={disabled}
            />
        </Cell>
    )
    const columns = [
        {
            name: 'supplierQARole',
            label: 'QA Status',
        },
        {
            name: 'suppliername',
            label: 'Child Supplier Name',
        },
        {
            name: 'address1',
            label: 'Address 1',
        },
        {
            name: 'address2',
            label: 'Address 2',
        },
        {
            name: 'city',
            label: 'City',
        },
        {
            name: 'state',
            label: 'State',
        },
        {
            name: 'zip',
            label: 'Zip',
        },
        {
            name: 'country',
            label: 'Country',
        },
        {
            name: 'phone',
            label: 'Phone',
        },
        {
            name: 'email',
            label: 'Email',
        },
    ]

    const headerElements = columns.map((col, index) => {
        if (index === 0) {
            return (
                <Column
                    resizable
                    sortable
                    key={col.name}
                >
                    <HeaderCell className='fw-bold text-black'>{col.label}</HeaderCell>
                    <LinkCell dataKey={col.name} />
                </Column>
            )
        }
        return (
            <Column
                resizable
                sortable
                key={col.name}
            >
                <HeaderCell className='fw-bold text-black'>{col.label}</HeaderCell>
                <Cell dataKey={col.name} />
            </Column>
        )
    })

    const handleSortColumn = (sortColumn, sortType) => {
        setLoading(true);
        setTimeout(() => {
            setLoading(false);
            setSortColumn(sortColumn);
            setSortType(sortType);
        }, 500);
    };

    const handleChangeLimit = dataKey => {
        setPage(1);
        setLimit(dataKey);
    }

    const handleCheckAll = (value, checked) => {
        let keys = checked ? tableData.map(item => item.id) : []
        if (checked) {
            setCheckedSuppliers(tableData)
        } else {
            setCheckedSuppliers([])
        }
        setCheckedKeys(keys)
        setIndeterminate(checked)
        setChecked(checked)
    }

    const handleCheck = (value, checked) => {
        const nextCheckedKeys = checked ? [...checkedKeys, value] : checkedKeys.filter(item => item !== value)
        setCheckedKeys(nextCheckedKeys)
        let tmpCheckedSuppliers = [...checkedSuppliers];
        if (checked) {
            tmpCheckedSuppliers = [...tmpCheckedSuppliers, tableData.find(row => row.id === value)]
        } else {
            tmpCheckedSuppliers = tmpCheckedSuppliers.filter(row => row.id !== value)
        }
        setCheckedSuppliers(tmpCheckedSuppliers)
    }

    const handleConfirmClick = () => {
        var childSuppliers = []
        let checked = false
        let indeterminate = false
        let showModal = false
        let headerText = ''
        if (!showNotSelectedChildSuppliersModal && tableData.length > checkedKeys.length) {
            childSuppliers = tableData.filter(supplier => !checkedKeys.includes(supplier.id))
            showModal = true
            headerText = 'Children to not merge with new master'
        } else {
            setIsMergingMasters(true)
            const selectedMasterId = masterSupplierData['id']
            var masterIdsToDelete = []
            var childrenToNotMerge = []
            var childSuppliers = []
            var addHistoryArray = []

            // get master Ids to merge
            selectedMasterSuppliers.map((supplier) => {
                if (supplier?.id !== selectedMasterId) {
                    masterIdsToDelete.push(supplier?.id)
                }
                return supplier.childVendors.map((child) => {
                    child['masterSupplierName'] = supplier?.suppliername
                    return childSuppliers.push(child)
                })
            })

            // get children Ids to not merge
            childSuppliers.filter(supplier => {
                if (!checkedKeys.includes(supplier?.id)) {
                    childrenToNotMerge.push(supplier.id)
                }
            })

            // to add merged masters History Note
            masterIdsToDelete.map(masterId => {
                let masterData = selectedMasterSuppliers.filter(supplier => {
                    if (supplier?.id === masterId) {
                        return supplier
                    }
                })
                let mergedNote = '<b>' + masterData?.[0]?.suppliername + '</b> was merged into <b>' + masterSupplierData?.suppliername + '</b> by <b><em>' + user?.firstname + ' ' + user?.lastname + '</em></b>';
                addHistoryArray.push({ id: masterSupplierData?.id, note: mergedNote })
            })

            // to add merged children History Note
            let assignedToMasterNote = 'Child supplier assigned to Master ' + '<a target="_blank" href="/suppliers/' + masterSupplierData?.id + '"><b>' + masterSupplierData?.suppliername + '</b></a> by <b><em>' + user?.firstname + ' ' + user?.lastname + '</em></b>';
            checkedKeys.map(value => {
                addHistoryArray.push({ id: value, note: assignedToMasterNote })
            })

            // to add children to not merge History Note
            childrenToNotMerge.map(value => {
                let SupllierData = childSuppliers.filter(supplier => {
                    if (supplier?.id === value) {
                        return supplier
                    }
                })
                let note = 'Child supplier removed from Master ' + '<a target="_blank" href="/suppliers/' + SupllierData?.[0]?.masterId + '"><b>' + SupllierData?.[0]?.masterSupplierName + '</b></a> by <b><em>' + user?.firstname + ' ' + user?.lastname + '</em></b>';
                addHistoryArray.push({ id: value, note: note })
            })

            dispatch(mergeMasters({
                selectedMasterId,
                masterIdsToDelete,
                childrenToMerge: checkedKeys,
                childrenToNotMerge
            })).then(async () => {
                toast.show({
                    title: 'Success',
                    description: 'Master Suppliers Merged Successfully!',
                })
                await dispatch(
                    addSupplierHistory({
                        supplierId: addHistoryArray,
                        note: '',
                        noteType: 'changelog'
                    })
                )
                setIsMergingMasters(false)
                onClose(true)
            }).catch(() => {
                setIsMergingMasters(false)
                toast.show({
                    title: 'Warning',
                    description: 'Failed to merge Master Suppliers!',
                })
            })
            return
        }
        setTableData(childSuppliers)
        setIndeterminate(indeterminate)
        setChecked(checked)
        setShowNotSelectedChildSuppliersModal(showModal)
        setHeaderText(headerText)
        setPage(1)
    }

    const handleRecheckClick = () => {
        var childSuppliers = []
        let checked = false
        let indeterminate = false
        selectedMasterSuppliers.map((supplier) => {
            return supplier.childVendors.map((child) => {
                return childSuppliers.push(child)
            })
        })
        if (checkedKeys && childSuppliers && checkedKeys.length === childSuppliers.length && checkedKeys.length > 0) {
            checked = true;
        } else if (checkedKeys && checkedKeys.length === 0) {
            checked = false;
        } else if (checkedKeys && childSuppliers && checkedKeys.length > 0 && checkedKeys.length < childSuppliers.length) {
            indeterminate = true;
        }
        setTableData(childSuppliers)
        setIndeterminate(indeterminate)
        setChecked(checked)
        setShowNotSelectedChildSuppliersModal(false)
        setPage(1)
        setHeaderText('Select the children to assign to new master supplier')
    }

    const paginatedTableData = tableData?.sort((a, b) => {
    }).slice(limit * (page - 1), limit * page)

    return (
        <>
            <Modal
                backdrop='static'
                className={`chils-suppliers-modal ${isMergingMasters && 'loading'}`}
                show={show}
                size="lg"
                onClick={() => { onClose(false) }}
                onHide={() => { onClose(false) }}
            >
                <Modal.Header>
                    <Modal.Title className='text-black'>
                        <div className='d-flex align-items-center gap-5'>
                            <h2 className='fw-bold text-blue mb-0'>New Master Supplier :</h2>
                            <h4 className='fw-bold text-black mb-0'>{masterSupplierData['suppliername']}</h4>
                        </div>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {isMergingMasters && <LoaderComponent />}
                    <div className="header row g-0 mb-3">
                        <div className='row g-0'>
                            <div className='col-12 d-flex align-items-center gap-5'>
                                <h3 className='text-black'> {headerText} </h3>
                            </div>
                        </div>
                    </div>
                    <div className="content border border-2 rounded record-body">
                        <Table
                            // virtualized={true}
                            height={500}
                            affixHeader={true}
                            data={paginatedTableData}
                            sortColumn={sortColumn}
                            sortType={sortType}
                            onSortColumn={handleSortColumn}
                            loading={loading}
                        >
                            {!showNotSelectedChildSuppliersModal && (
                                <Column width={50} align="center">
                                    <HeaderCell style={{ padding: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                        <Checkbox
                                            checked={checked}
                                            indeterminate={indeterminate}
                                            onChange={handleCheckAll}
                                        />
                                    </HeaderCell>
                                    <CheckCell
                                        dataKey="id"
                                        checkedKeys={checkedKeys}
                                        onChange={handleCheck}
                                    />
                                </Column>
                            )}
                            {headerElements}
                        </Table>
                        <div className="child-vendor-table-pagination">
                            <Pagination
                                prev
                                next
                                first
                                last
                                maxButtons={5}
                                activePage={page}
                                showInfo
                                layout={['limit', '|', 'pager']}
                                displayLength={limit}
                                lengthMenu={[
                                    {
                                        label: '10',
                                        value: 10,
                                    },
                                    {
                                        label: '20',
                                        value: 20,
                                    },
                                    {
                                        label: '30',
                                        value: 30,
                                    },
                                    {
                                        label: '50',
                                        value: 50,
                                    },
                                    {
                                        label: '100',
                                        value: 100,
                                    },
                                ]}
                                total={tableData.length}
                                onChangePage={(event) => { setPage(event) }}
                                onChangeLength={handleChangeLimit}
                            />
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer className='pe-3'>
                    <div className="action-container float-end pe-3">
                        <button type="button" className="text-white rounded bg-green me-0 p-5 pt-3 pb-3 h4 mb-0" onClick={handleConfirmClick}>
                            Confirm
                        </button>
                        {showNotSelectedChildSuppliersModal && (
                            <button type="button" className="ms-5 text-white rounded bg-gray me-0 p-5 pt-3 pb-3 h4 mb-0" onClick={handleRecheckClick}>
                                Go Back
                            </button>
                        )}
                    </div>
                </Modal.Footer>
            </Modal>
        </>
    )
}
export default ChildSuppliersModal